import { render, staticRenderFns } from "./DigitalHuman.vue?vue&type=template&id=6bbc4c4c&scoped=true&"
import script from "./DigitalHuman.vue?vue&type=script&lang=js&"
export * from "./DigitalHuman.vue?vue&type=script&lang=js&"
import style0 from "./DigitalHuman.vue?vue&type=style&index=0&id=6bbc4c4c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc4c4c",
  null
  
)

export default component.exports